var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoXl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 70,
    viewBox: "0 0 283 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3835_122411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8912 22.9353V53.9025H91.3166V22.9353V21.7412H92.5204H103.287V16.1426H71.8867V21.7412H82.6873H83.8912V22.9353Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.881 48.3374H152.486H151.282V47.1321V39.0326V37.8273H152.486H165.976V32.1949H152.486H151.282V30.9895V22.8901V21.6847H152.486H170.881V16.041H143.891V53.9474H170.881V48.3374Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.37 37.5008L181.13 16.1426H173.491L193.461 53.4631L213.521 16.1426H205.769L194.496 37.5008L193.427 39.5172L192.37 37.5008Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.346 47.1321V39.0326V37.8273H226.55H240.039V32.1949H226.55H225.346V30.9895V22.8901V21.6847H226.55H244.933V16.041H217.954V53.9474H244.933V48.3374H226.55H225.346V47.1321Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.268 35L269.741 34.3128L282.398 16.1426H274.072L266.096 27.5652L265.106 28.9733L264.127 27.5652L256.161 16.1426H247.847L260.437 34.3128L260.92 35L260.437 35.6872L247.836 53.8799L256.161 53.9025L264.116 42.4348L265.106 41.0154L266.096 42.4348L274.084 53.9025H282.398L269.741 35.6872L269.268 35Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.794 39.4046C132.404 38.5597 133.54 37.8387 135.093 36.0476C136.972 33.8622 137.883 31.6205 137.883 29.1873V28.1397C137.883 24.197 136.443 22.2819 133.608 19.9501C130.593 17.4944 126.329 16.1426 121.615 16.1426H106.91L106.944 53.9025H114.336V35.2253H114.302V21.73H121.007C123.775 21.73 126.374 22.4397 127.803 23.5887H127.825L127.836 23.6112C129.4 24.963 130.188 26.5626 130.188 28.3875C130.188 32.1725 126.756 35.2478 122.549 35.2478H118.082V35.2253H115.404L116.484 36.5883L130.12 53.8912H139.042L129.22 41.2858L128.163 39.934L129.794 39.4046Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1813 47.5258H32.8584V69.988L65.0915 37.7141C54.4371 36.3849 44.7953 35.8104 36.2786 35.709L39.1813 47.5146V47.5258Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.602539 32.2964C7.02666 33.4567 16.8372 34.7296 29.6292 34.9549L29.7867 34.3241C27.8516 33.2427 26.5353 31.1699 26.5353 28.793C26.5353 25.3009 29.3704 22.4622 32.8581 22.4622V0",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.858 69.9992V47.537H26.5352L29.4378 35.7539C17.1296 35.9792 7.60033 37.1845 1.20996 38.311L21.9561 45.9374L32.8693 70.0104L32.858 69.9992Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1813 28.8043C39.1813 31.1812 37.8762 33.2539 35.9298 34.3354L36.0873 34.9887C44.8178 34.8986 54.7296 34.3016 65.7103 32.9047L43.7603 24.0731L32.8584 0V22.4734C36.3461 22.4734 39.1813 25.3122 39.1813 28.8043Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7215 32.9047L32.8584 0L43.7715 24.0731L65.7215 32.9047Z",
    fill: "url(#paint0_linear_3835_122411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7215 32.9047L32.8584 0L43.7715 24.0731L65.7215 32.9047Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9454 45.9271L1.19922 38.3008L32.8585 70.0002L21.9454 45.9271Z",
    fill: "url(#paint1_linear_3835_122411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9454 45.9271L1.19922 38.3008L32.8585 70.0002L21.9454 45.9271Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3835_122411",
    x1: 44.6153,
    y1: 36.0251,
    x2: 49.4872,
    y2: 15.6497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3835_122411",
    x1: 25.9956,
    y1: 37.7601,
    x2: 16.8198,
    y2: 54.4899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3835_122411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281.795,
    height: 70,
    fill: "white",
    transform: "translate(0.602539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXl);
export default __webpack_public_path__ + "static/media/logoXL.585df28df672b86e8a559b515e143f98.svg";
export { ForwardRef as ReactComponent };